import api from './api';

export const authService = {
  async register(data) {
    const response = await api.post('/auth/register', data);
    return response.data;
  },

  async login(email, password) {
    const response = await api.post('/auth/login', { email, password });
    return response.data;
  },

  async logout() {
    const response = await api.post('/auth/logout');
    return response.data;
  },

  async getUser() {
    const response = await api.get('/user');
    return response.data;
  },

  async updateUser(data) {
    const response = await api.put('/user', data);
    return response.data;
  },

  async uploadKyc(file) {
    const formData = new FormData();
    formData.append('document', file);
    const response = await api.post('/user/kyc', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  async startKycVerification() {
    const response = await api.post('/user/kyc/verify');
    return response.data;
  },

  async getKycStatus() {
    const response = await api.get('/user/kyc/status');
    return response.data;
  },

  async forgotPassword(email) {
    const response = await api.post('/auth/forgot-password', { email });
    return response.data;
  },

  async verifyResetCode(email, code) {
    const response = await api.post('/auth/verify-reset-code', { email, code });
    return response.data;
  },

  async resetPassword(data) {
    const response = await api.post('/auth/reset-password', data);
    return response.data;
  },
};
